export default __webpack_public_path__ + "static/media/ansible.93162708.svg";